'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlModuleDette", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: "<span tl-tooltip=\"Dette et financement\" class=\"mr-s module-dette\">D</span>"
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/modules/tl-module-dette.js
// module id = 2857
// module chunks = 13